import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import Backend from "i18next-http-backend"
import { initReactI18next } from "react-i18next"

import { DEFAULT_LOCALE, FALLBACK_LOCALE, LOCALES, LOCALE_STORAGE_KEY, NAMESPACES } from "./config"

void i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: [...LOCALES],
    fallbackLng: FALLBACK_LOCALE,
    defaultNS: "common",
    ns: [...NAMESPACES],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "htmlTag", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: LOCALE_STORAGE_KEY,
    },
    backend: { loadPath: "/locales/{{lng}}/{{ns}}.json" },
    returnNull: false,
  })
  // Bootstrap before the logger exists — console.error is sanctioned here
  // per logging-discipline.md §A.
  .catch((e) => console.error("i18n init failed", e))

// Keep <html lang="…"> in sync with the active locale.
i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng
})
document.documentElement.lang = i18n.language || DEFAULT_LOCALE

export default i18n
